<template>
<section class="content close-date-picker city_collection_reports_pop report_generation_progress_main" style="position: relative">
    <div class="box-body">
        <div :class="[addButtonClass, {'general_reports_btn1': (tableCount <= 10)}]" class="general_reports_btn">
            <button class="btn gradientbt" @click="refreshReportList">
                Refresh
            </button>
            <button class="btn gradientbt ml-5" @click="gotoReportGeneration">
                Generate Reports
            </button>
        </div>
        <v-server-table ref="tripReportTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
            <template slot="beforeBody">
                <tr v-if="loading" class="VueTables__no-results">
                    <td class="text-center" colspan="9">
                        <pulse-loader></pulse-loader>
                    </td>
                </tr>
            </template>
            <template slot="action" slot-scope="props">
                <div class="d-flex">
                    <div class="c-pointer report_generation_progress">
                        <a v-if="props.row.fileUrl == ''" disabled>Report Generation In Progress.</a>                  
                    <a class="fa fa-download" role="button" v-if="props.row.fileUrl != ''" v-bind:href="props.row.fileUrl" target="_blank"></a>
                        <!-- <a v-bind:href="props.row.fileUrl" target="_blank">Download</a> -->
                    </div>
                </div>
            </template>
        </v-server-table>
    </div>

    <div v-if="isGenerateReport" class="">
        <div v-if="isGenerateReport" class="">
            <div class="">
                <div class="">
                    <div id="details" class="overlay waste_type_pop">
                        <div class="overlay_inner">
                            <div class="row form-modal">
                                <vue-form :state="formstate" @submit.prevent="onSubmit">
                                    <h4 class="text-center">Generate Reports</h4>
                                    <div v-if="reportLoading" class="content content-centered">
                                        <pulse-loader></pulse-loader>
                                        <p>Please wait, report generation is in progress.</p>
                                    </div>

                                    <div v-if="!reportLoading" class="col-sm-12 scroll_pop" style="padding-top: 15px">
                                        <div class="col-sm-12 " v-if="adminCheck == 'superAdmin'">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.city)">
                                                <label>Select City</label>
                                                <multiselect track-by="value" v-model="tripReport.city" :disabled="isCityDisable" label="name" placeholder="Select City" :options="cityList" name="city" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedCity" @remove="onRemoveCity" required>
                                                </multiselect>                                           
                                                <field-messages name="city" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>

                                        <div class="col-sm-12">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicles)">
                                                <label>Vehicle Number</label>
                                                <multiselect track-by="id" v-model="tripReport.vehicles" @input="vehicleNumberBtn" label="name" placeholder="Select Vehicle" :options="vehicleList" multiple name="vehicle" selectLabel="" deselectLabel="" selectedLabel="" @select="getVehicle" @remove="onRemoveVehicle">
                                                    <span style="display: block" slot="noResult">Oops! No elements found</span>
                                                </multiselect>
                                                <field-messages name="vehicle" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                        <div class="col-sm-12">
                                            <div>
                                <h5 class="boxs1">Trip Schedule Date Range</h5>
                            </div>
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.startDate)">
                                                <label>Start Range</label>
                                                <date-picker id="startDate" required v-model="tripReport.startDate" lang="en" name="startDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY" @change="datevalidation" :not-after="disabledAfter"></date-picker>
                                                <field-messages name="startDate" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>

                                        <div class="col-sm-12">
                                            <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.endDate)">
                                                <label>End Range</label>
                                                <date-picker id="endDate" required v-model="tripReport.endDate" lang="en" name="endDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY" @change="datevalidation1" :not-before="notBeforeEndDate" :not-after="enddateDisabledAfter"></date-picker>
                                                <field-messages name="endDate" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">This is required field</div>
                                                </field-messages>
                                            </validate>
                                        </div>
                                    </div>

                                </vue-form>
                                <div class="form-actions">
                                    <button class="mr-5 btn btn-default" type="button" @click="onModalClose">
                                        Cancel
                                    </button>                                  
                                    <button class="mr-2 btn gradientbt" type="submit" @click="generateReport" :disabled="!(formstate.$dirty && formstate.$valid && vehicleNumberBtnFlag)">
                                        Generate
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import {
    USER_ROLES
} from "../../../config";
import {
    Event
} from "vue-tables-2";
import moment from "moment";
import {
    mapState
} from "vuex";
import {
    eventBus,
    formService,
    primarytripService,
    reportsService,
} from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import {
    fa
} from "faker/lib/locales";
export default {
    name: "tripReports",
    data() {
        return {
            vehicleNumberBtnFlag:false,
            show: false,
            showw: false,
            page: null,
            limit: null,
            loading: null,
            tripReportTable: null,
            parameters: {},
            noResult: true,
            endLocForDateFilter: "",
            isGenerateReport: false,
            tableCount:"",
            reportLoading: false,
            formstate: {},
            tripReport: {
                city: '',
                vehicles: [],
            },
            isCityDisable: false,
            cityList: [],
            vehicleList: [],
            disabledAfter: new Date(),
            enddateDisabledAfter: null,
            notBeforeEndDate: null,
            endDateFormat: null,
            columns: [
                "vehicleNumber",
                "date",
                "createdAt",
                "createdBy",
                "action",
            ],
            options: {
                highlightMatches: true,
                headings: {
                    city: "City",
                    vehicleNumber: "Vehicle Number",
                    date: "Date Range",
                    createdAt: "Generated At",
                    createdBy: "Generated By",
                    action: "Action",
                },
                templates: {
                    scheduleTime(row, query) {
                        return dateFormatter(query.scheduleTime);
                    },
                },
                perPage: 10,
                sortable: [
                    "city",
                    "vehicleNumber",
                    // "date",
                    "createdAt",
                    "createdBy"
                ],
                requestFunction: (request) => {
                    this.parameters.page = request.page;
                    this.parameters.limit = request.limit;
                    if (request.orderBy) {
                        this.parameters.sortBy = request.orderBy;
                        if (request.ascending == 1) {
                            this.parameters.sortOrder = "asc";
                        } else {
                            this.parameters.sortOrder = "dsc";
                        }
                    }
                    if (request.query != "") {
                        this.parameters.searchString = request.query.trim();
                    } else {
                        delete this.parameters.searchString;
                    }

                    return reportsService
                        .getTripReportList(this.parameters)
                        .catch((error) => {
                            console.error("trip.requestFunction-error:", error);
                            this.$snotify.error("Get Trip", "Error!");
                        });
                },
                responseAdapter: (response) => {
                    this.loading = false;
                    let dataResp = [];
                    response.data.response[0].vehicleReportData.forEach((element) => {
                        let finalData = element;
                        finalData["date"] =
                            element.startDate && element.endDate ?
                            moment(String(element.startDate)).format("DD-MM-YYYY") +
                            " to " +
                            moment(String(element.endDate)).format("DD-MM-YYYY") :
                            "--";
                        finalData["createdAt"] = element.createdAt ?
                            dateFormatter(element.createdAt) :
                            "--";
                        // finalData["createdAt"] = element.createdAt ?
                        //     moment(String(element.createdAt)).format("DD-MM-YYYY") :
                        //     "--";
                        dataResp.push(finalData);
                    });
                    return {
                        data: dataResp,
                        count: response.data.totalCount,
                    };
                },
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        addButtonClass() {
            if (this.tripReportTable) {
                this.tableCount = this.tripReportTable.count
                return this.tripReportTable.count > this.tripReportTable.limit ||
                    this.tripReportTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        fieldClassName: formService.fieldClassName,


        vehicleNumberBtn(){
                if(this.tripReport.vehicles.length>0){
                    this.vehicleNumberBtnFlag = true
                }else{
                    this.vehicleNumberBtnFlag = false

                }
            },
     

        gotoReportGeneration() {
            if (this.adminCheck == "superAdmin") {
                this.vehicleList = [];
            }
            this.tripReport.vehicles = [];
            //   this.tripReport.startDate = "";
            //   this.tripReport.endDate = "";
            this.isGenerateReport = true;
            eventBus.$on('cityIdChanged', this.onChecked);
        
            if(this.$store.state.auth.user.role.key !== "cityAdmin" || this.$store.state.auth.user.role.key !== "subCityAdmin"){
                this.isCityDisable = true
                this.tripReport.city = this.$store.state.auth.cityId
                this.getVehicleList(this.$store.state.auth.cityId.value);
               
            }
        },
        onChecked(option){
            this.tripReport.city = option
            this.getVehicleList(option.value);
        },
        generateReport() {
            this.reportLoading = true;
            let reportData = {};
            reportData["type"] = "html";
            if (this.$store.state.auth.user.role.key == "superAdmin") {
                reportData["cityId"] = this.tripReport.city.value;
            }
            reportData["vehicleId"] = this.tripReport.vehicles
                .map((element) => element.id)
                .join(",");
            reportData["startDate"] = moment(
                String(this.tripReport.startDate)
            ).format("YYYY-MM-DD");
            reportData["endDate"] = moment(String(this.tripReport.endDate)).format(
                "YYYY-MM-DD"
            );
            return reportsService
                .getTripReport(reportData)
                .then((response) => {
                    this.reportLoading = false;
                    if (!response.data.error) {
                        const renderedHTML = response.data;
                        // Open the rendered HTML in a new tab
                        const newTab = window.open("", "_blank");
                        // newTab.document.open();
                        if (newTab) {
                            newTab.document.write(renderedHTML);
                            newTab.document.close();
                        }
                        // this.isGenerateReport = false;
                    } else {
                        // this.isGenerateReport = false;
                        this.$snotify.error(response.data.error, "Error!");
                    }
                    this.tripReport.vehicles = "";
                    this.tripReport.startDate = "";
                    this.tripReport.endDate = "";
                    this.isGenerateReport = false;
                    this.$refs.tripReportTable.refresh();
                })
                .catch((error) => {
                    this.tripReport.vehicles = "";
                    this.tripReport.startDate = "";
                    this.tripReport.endDate = "";
                    this.$snotify.error(error.data.message, "Error!");
                    this.reportLoading = false;
                });
        },
        refreshReportList() {
            this.$refs.tripReportTable.refresh();
            this.loading = true;
        },
        onModalClose() {
       
            this.tripReport.vehicles = [];
            this.tripReport.startDate = "";
            this.tripReport.endDate = "";
            this.isGenerateReport = false;
        },

        clearStatus() {
            delete this.parameters["status"];
            this.statusValue = "";
            this.$refs.tripReportTable.refresh();
        },

        onCheckedCity(option) {
            this.vehicleNumberBtnFlag = false 
            this.tripReport.vehicles = [];
            this.vehicleList = [];
            let cityId = option.value;
            this.getVehicleList(cityId);
        },
        onRemoveCity() {
            this.vehicleNumberBtnFlag = false            
            this.tripReport.vehicles = [];
            this.vehicleList = [];
        },

        getVehicle(option) {
            
        },

        onRemoveVehicle(data) {            
        //     if(data== ""){
        //     this.vehicleNumberBtnFlag = false
        // }
        },

        getVehicleList(id) {
            this.vehicleList = [];
            let vehicle_nameList = [];
            return primarytripService
                .vehicleList(id)
                .then((res) => {
                    res.data.response.forEach((element) => {
                        if (element.status == true) {
                            vehicle_nameList.push({
                                name: element.vNumber,
                                id: element._id,
                            });
                        }
                    });
                    vehicle_nameList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.vehicleList = vehicle_nameList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Vehicle.requestFunction-error:", error);
                    this.$snotify.error("Vehicle list failed", "Error!");
                });
        },
        datevalidation(event) {
            let date = new Date(event);
            let startEpoch = date.getTime();

            if (this.endDateFormat) {
                let endEpoch = new Date(this.endDateFormat).getTime();
                if (startEpoch > endEpoch) {
                    this.tripReport.endDate = "";
                }
            }

            this.notBeforeEndDate = new Date(event).toISOString();
            let endDateAfter14Days = new Date(date.setDate(date.getDate() + 14));
            this.enddateDisabledAfter = endDateAfter14Days.toISOString();
            this.isEndDateDisable = false;
        },

        // datevalidation(event) {
        //     let d = new Date(event).toISOString();
        //     var date = new Date(d);
        //     let startEpoch = date.getTime();
        //     if (this.endDateFormat) {
        //         let endEpoch = this.endDateFormat.getTime();
        //         if (startEpoch && endEpoch && startEpoch > endEpoch) {
        //             this.tripReport.endDate = "";
        //         }
        //     }

        //     this.notBeforeEndDate = new Date(event).toISOString();
        //     this.enddateDisabledAfter = new Date(date.setDate(date.getDate() + 14));
        //     this.isEndDateDisable = false;
        // },

        datevalidation1(event) {
            // let d = new Date(event).toISOString();
            // var date = new Date(d);
            // this.endDateFormat = date;
        },

        UpdateDestination(row) {
            if (row.status == "ongoing") {
                this.$router.push({
                    name: "UpdateDestination",
                    params: {
                        _id: row._id,
                    },
                    props: row,
                });
            }
        },
        action(row) {
            this.$router.replace({
                name: "viewPrimaryTrip",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },
        onLoaded() {
            this.tripReportTable = this.$refs.tripReportTable;
        },
        onCheckedCityFilter(option){

            this.parameters.cityId = option.value
            this.$refs.tripReportTable.refresh()
        },

        getCityList() {
            const params = {};
            this.cityList = [];
            let cities = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cities.push({
                                name: element.cityName.length > 20 ?
                                    element.cityName.slice(0, 20) + "..." : element.cityName,
                                value: element._id,
                            });
                        }
                    });
                    cities.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.cityList = cities;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");
                });
        },

        viewReport(data) {},
        downloadReport(data) {},
    },
    mounted() {
        eventBus.$on('cityIdChanged', this.onCheckedCityFilter);
        if (this.$store.state.auth.user.role.key === "superAdmin") {
            this.columns.unshift("city");
            this.getCityList();
        }

    },
    created() {
        this.adminCheck = this.$store.state.auth.user.role.key;
        if(this.adminCheck === "superAdmin"){
            this.parameters.cityId = this.$store.state.auth.cityId.value
        }
        let cityId =
            this.$store.state.auth.user.cityId &&
            this.$store.state.auth.user.cityId._id ?
            this.$store.state.auth.user.cityId._id :
            "";
        if (this.adminCheck !== "superAdmin") {
            this.getVehicleList(cityId);
        }
    },
};
</script>

<style scoped>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 225px;
    margin-left: 250px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.inline {
    background-color: rgba(255, 132, 78);
    color: white;
}

.addnew {
    background-image: linear-gradient(to right,
            rgba(38, 153, 251),
            rgba(146, 205, 255));
    color: white;
}

.main_select_wrp_relative .modal-dialog {
    width: 50% !important;
}

.main_select_wrp_relative {
    position: absolute;
    right: 30%;
    top: 25px;
}

.filter_wrpp button svg {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.filter_wrpp button {
    display: flex;
    align-items: center;
    margin-right: 5px;
}

.filter_wrpp button:hover {
    background: #0f6940;
    color: #fff;
}

.main_select_wrp_relative+.add-item {
    display: flex;
}
.general_reports_btn1 {
    right: 26px !important;
}
.select_date_wrp .datedrop_boxs {
    position: static;
    width: 100%;
    padding: 0px;
    box-shadow: none;
    border: transparent;
}

.select_date_wrp {
    margin-top: 20px;
}

.select_date_wrp .datedrop_boxs_wrp {
    float: initial;
    background: transparent;
    margin-right: 0;
}

/* .dates_left label {
    color: #000;
} */

.scroll_pop {
    padding-top: 15px;
    height: 327px;
    overflow: auto;

}
.scroll_pop::-webkit-scrollbar {
  width: 5px;
}
.scroll_pop::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
.scroll_pop::-webkit-scrollbar-thumb {
  background: #888; 
}

.dates_left {
    flex: 0 0 32.5%;
    margin-right: 10px;
}

.clearButton {
    margin-right: 33px;
    opacity: 0.8;
    color: blue;
    text-decoration: underline;
    font-size: large;
}
.boxs1{
    font-size:16px !important;
    font-weight: bold !important;
}
.form-modal-report .multiselected {
    min-width: 100%;
    min-height: 90px;
}

.form-modal-report {
    background: #fff;
}

.report .generate_report_pop .form-modal-report {
    width: 40%;
    height: 55%;
    padding: 24px 15px;
}
.report_generation_progress a{
    font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// vehicle_trip_reports.vue?553ec19a